<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import PoiDetailsSubpoiButton from '@/components/PoiDetailsSubpoiButton.vue';
import { Icon } from '@/components/ui';
import { usePois } from '@/composables';

const { selectedPoi, selectedSubpoiIndex, selectedPoiSubpoisLength } = usePois();
const { t } = useI18n();
</script>

<template>
  <div
    v-if="selectedPoi"
    class="size-full"
    :style="`--filler-50: var(--markets-${selectedPoi.category})`"
  >
    <div class="grid size-full grid-cols-8 grid-rows-8 gap-4">
      <div
        :class="{
          'col-span-4 col-start-1 row-start-7 mx-auto': selectedPoiSubpoisLength === 2 && i === 1,
          'col-span-4 col-start-5 row-start-7 mx-auto': selectedPoiSubpoisLength === 2 && i === 2,

          'col-span-8 col-start-1 row-start-3 mr-auto': selectedPoiSubpoisLength === 3 && i === 1,
          'col-span-8 col-start-1 row-start-5 ml-auto': selectedPoiSubpoisLength === 3 && i === 2,
          'col-span-8 col-start-1 row-start-7 mr-auto': selectedPoiSubpoisLength === 3 && i === 3,

          'col-span-4 col-start-1 row-start-3 mr-auto': selectedPoiSubpoisLength === 4 && i === 1,
          'col-span-4 col-start-5 row-start-3 ml-auto': selectedPoiSubpoisLength === 4 && i === 2,
          'col-span-4 col-start-1 row-start-7 mr-auto': selectedPoiSubpoisLength === 4 && i === 3,
          'col-span-4 col-start-5 row-start-7 ml-auto': selectedPoiSubpoisLength === 4 && i === 4,
        }"
        v-for="i in selectedPoiSubpoisLength"
        :key="i"
      >
        <PoiDetailsSubpoiButton @click="selectedSubpoiIndex = i" class="pointer-events-auto">
          <Icon class="size-10" :name="selectedPoi.category" />
          {{ t(`poi-details-card.${selectedPoi.category}.${selectedPoi.name}.${i}.title`) }}
        </PoiDetailsSubpoiButton>
      </div>
    </div>
  </div>
</template>
